export default __webpack_public_path__ + "static/media/CarrerJourneyMap.afa39145.svg";